import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { StatsCalc } from "../components/StatsCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.st_tool_name()}
        toolPath="/statistics-calculator"
      />
      <SciHeader title={m.st_h1()} intro={m.st_intro()} />
      <StatsCalc />
      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.st_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.st_ex1(), m.st_ex2(), m.st_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.st_faq_q1(), a: m.st_faq_a1() },
          { q: m.st_faq_q2(), a: m.st_faq_a2() },
          { q: m.st_faq_q3(), a: m.st_faq_a3() },
          { q: m.st_faq_q4(), a: m.st_faq_a4() },
        ]}
      />
      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
